module.exports = __webpack_public_path__ + "static/media/logoCentermaq1.00bb6041.png";